import axios, { HttpStatusCode } from 'axios';
import { useLocalStorage } from 'src/hooks/storage.hook';
import { routes } from 'src/data/routes';
import { API_ROUTES } from '../data/routes';

const requestIntstance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
    },
});

requestIntstance.interceptors.request.use((config) => {
    const { getObject } = useLocalStorage();
    const token = getObject('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token.token}`;
    }
    return config;
});

requestIntstance.interceptors.response.use((response) => {
    return response
}, async function (error) {
    const originalRequest = error?.config;
    if (originalRequest && error?.response?.status === HttpStatusCode.Unauthorized && !originalRequest?._retry) {
        RefreshToken(originalRequest);
    }
    return Promise.reject(error);
});


const RefreshToken = async (originalRequest: any) => {
    originalRequest._retry = true;
    const { getObject, setObject } = useLocalStorage();
    try {
        const dataToken = getObject('token');
        const { refreshToken, token } = dataToken;
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api${API_ROUTES.REFRESH_TOKEN}`, {}, { headers: { ['refresh-token']: refreshToken, Authorization: `Bearer ${token}` } });
            const tokenData = response.data.data;
            setObject('token', tokenData);
            originalRequest.headers.Authorization = `Bearer ${tokenData.token}`;
        return await requestIntstance(originalRequest);
    } catch (error) {
        logout();
        return Promise.reject(error);
    }
}


export class HttpClient {
    static async get<T>(url: string, data?: unknown) {
        const params = setParams(data)
        const response = await requestIntstance.get<T>(url, params);
        return response.data;
    }

    static async post<T>(url: string, data: unknown, options?: any) {
        const response = await requestIntstance.post<T>(url, data, options);
        return response.data;
    }

    static async put<T>(url: string, data: unknown, options?: any) {
        const response = await requestIntstance.put<T>(url, data, options);
        return response.data;
    }


}

const setParams = (params: any) => {
    for (const key in params) {
        if (!params[key]) { delete params[key] }
    }

    return params;
}


const logout = () => {
    localStorage.clear();
    window.location.href = routes.LOGIN;

}